import {
  MeiliOrigin,
  MeiliSuggestedThought,
  MeiliThought,
} from "@/generated/fastapi";
import type { GenericOptionItem } from "@/shared/ui/controls/option.types";
import {
  MEILI_INDEX_ORIGINS,
  MEILI_INDEX_SUGGESTED_THOUGHTS,
  MEILI_INDEX_THOUGHTS,
  type SearchIndexName,
  SEARCH_HITS_PER_PAGE_OPTIONS,
  SEARCH_SORT_NEWEST,
  SEARCH_SORT_OLDEST,
} from "./keys";

export type MeiliDocumentType =
  | MeiliOrigin
  | MeiliSuggestedThought
  | MeiliThought;

export type SearchSortOption = GenericOptionItem;

export type SearchIndexConfig = {
  indexName: SearchIndexName;
  title: string;
  mainContentField:
    | keyof MeiliOrigin
    | keyof MeiliSuggestedThought
    | keyof MeiliThought;
  filters: string[];
  sortBy: SearchSortOption[];
};

export type BacklogConfigItem = SearchIndexConfig;

export type MeiliIndexMap = {
  origins: MeiliOrigin;
  suggested_thoughts: MeiliSuggestedThought;
  thoughts: MeiliThought;
};

const MEILI_SEARCH_CONFIG_DATA: Record<SearchIndexName, SearchIndexConfig> = {
  [MEILI_INDEX_ORIGINS]: {
    indexName: MEILI_INDEX_ORIGINS,
    title: "archive",
    mainContentField: "raw_text_input",
    filters: ["language", "processed_status"],
    sortBy: [
      { value: "origins:latest_at:desc", label: SEARCH_SORT_NEWEST },
      { value: "origins:latest_at:asc", label: SEARCH_SORT_OLDEST },
    ],
  },
  [MEILI_INDEX_SUGGESTED_THOUGHTS]: {
    indexName: MEILI_INDEX_SUGGESTED_THOUGHTS,
    title: "suggestions",
    mainContentField: "mindstring",
    filters: ["language", "prototype"],
    sortBy: [
      {
        value: "suggested_thoughts:latest_at:desc",
        label: SEARCH_SORT_NEWEST,
      },
      {
        value: "suggested_thoughts:latest_at:asc",
        label: SEARCH_SORT_OLDEST,
      },
    ],
  },
  [MEILI_INDEX_THOUGHTS]: {
    indexName: MEILI_INDEX_THOUGHTS,
    title: "profile",
    mainContentField: "mindstring",
    filters: ["language", "prototype"],
    sortBy: [
      { value: "thoughts:latest_at:desc", label: SEARCH_SORT_NEWEST },
      { value: "thoughts:latest_at:asc", label: SEARCH_SORT_OLDEST },
    ],
  },
};

export const MEILI_SEARCH_CONFIG: Readonly<
  Record<SearchIndexName, SearchIndexConfig>
> = Object.freeze(MEILI_SEARCH_CONFIG_DATA);

export const DEFAULT_SEARCH_HITS_PER_PAGE = Object.freeze(
  [...SEARCH_HITS_PER_PAGE_OPTIONS],
);

export const DEFAULT_HITS_PER_PAGE = DEFAULT_SEARCH_HITS_PER_PAGE;

export function getDefaultSearchSortValue(config: SearchIndexConfig): string {
  return config.sortBy[0]?.value ?? "";
}
